import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class PaymentMethodLiteModel extends CommonModel {
  type: string;
}

export class PaymentMethodModel extends PaymentMethodLiteModel {}

//query
export type getPaymentMethodsInput = {
  params: CommonParamInput;
};

export type getPaymentMethodInput = {
  id: string;
};
